import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import DashboardPresentation from '../components/DashboardPresentation'
import { getPublicDashboard } from '../services/publicDashboardApi'
import '../styles/dashboard.css'
import './PublicDashboardScreen.css'

const UNAVAILABLE_MESSAGE = 'Shared dashboard unavailable.'

function PublicDashboardScreen() {
  const { token } = useParams()
  const [dashboard, setDashboard] = useState(null)
  const [loading, setLoading] = useState(true)
  const [unavailable, setUnavailable] = useState(false)

  useEffect(() => {
    const robots = document.querySelector('meta[name="robots"]')
    const previousRobots = robots?.getAttribute('content')
    if (robots) robots.setAttribute('content', 'noindex,nofollow')

    return () => {
      if (robots) {
        if (previousRobots === null) robots.removeAttribute('content')
        else robots.setAttribute('content', previousRobots)
      }
    }
  }, [])

  useEffect(() => {
    let active = true
    setLoading(true)
    setUnavailable(false)
    getPublicDashboard(token)
      .then(data => { if (active) setDashboard(data) })
      .catch(() => { if (active) setUnavailable(true) })
      .finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [token])

  if (loading) return <main role='status' className='public-dashboard-surface dashboard-main-container'>Loading shared dashboard…</main>
  if (unavailable || !dashboard) return <main role='alert' className='public-dashboard-surface dashboard-main-container'>{UNAVAILABLE_MESSAGE}</main>

  return (
    <main className='public-dashboard-surface dashboard-main-container'>
      <header className='public-dashboard-header'>
        {dashboard.image && <img className='public-dashboard-icon' src={`/static/dashboard-icons/${dashboard.image}`} alt={`${dashboard.name} icon`} />}
        <div className='public-dashboard-heading'>
          <h1 className='p-title public-dashboard-title'>{dashboard.name}</h1>
          {dashboard.description && <p className='p-paragraph public-dashboard-description'>{dashboard.description}</p>}
        </div>
      </header>
      <DashboardPresentation widgets={dashboard.widgets} backgroundColor={dashboard.background_color} />
    </main>
  )
}

export default PublicDashboardScreen
